import React from 'react';
export var AuthContext = React.createContext({
    user: undefined,
    loading: true,
});
